import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { LabTech } from '../LabTechsContext'
import { HelpMessage } from 'utils/constants'
import { breakDataTags } from '../../../utils/breakDataTags'

export function useExpand(): ExpandOptions<LabTech> {
  const help = HelpMessage.Concrete.LabTechs.LabTechs
  return {
    expandable: ({
      concreteCoreBreakDatas,
      concreteTestBreakDatas,
      testingLabs,
    }) =>
      !!concreteCoreBreakDatas.length ||
      !!concreteTestBreakDatas.length ||
      !!testingLabs.length,
    render: (labTech) => {
      const { name, testingLabs } = labTech
      return {
        additionalInfo: [
          {
            type: 'tags',
            label: 'Testing Labs',
            help: help.TestingLabs(name),
            tags: testingLabs.map(({ name }) => ({ text: name })),
          },
          breakDataTags(labTech),
        ],
      }
    },
  }
}
